export const LoginMethodEnumArray = ['emailpassword', 'phonepassword'] as const
export type LoginMethodEnum = (typeof LoginMethodEnumArray)[number]
